import { ILoggerOutput, logger, LogLevel } from './logger';

const isWorker = typeof WorkerGlobalScope !== 'undefined' && self && self instanceof WorkerGlobalScope;
const isNode = typeof process !== 'undefined' && process.versions?.node != null;

export function trackWorkerExceptions(worker: Worker) {
    worker.addEventListener('message', (e) => {
        if (e.data.type === '@@track-exception') {
            logger.trackException(e.data.error);
        }
    });
}

export class WorkerExceptionTracker implements ILoggerOutput {
    constructor() {
        if (!isNode) {
            if (!isWorker) {
                throw new Error('This logger output is intended to be used only in a web worker.');
            }
            self.addEventListener('error', (e) => {
                logger.trackException(e.error);
            });
        }
    }

    log(level: LogLevel, args: any[]) {
        // pass
    }

    exception(error: unknown) {
        if (!(error instanceof Error)) {
            return;
        }

        self.postMessage({ type: '@@track-exception', error });
    }
}
